import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushSmoothIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.5,
			d: "M2 9c3-4 4 4 7 0s4-4 7 0 4 4 6 0",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.2,
			d: "M2 16h20"
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.8,
			d: "M12 11v3",
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.5,
			d: "m10 13 2 2 2-2",
			opacity: .5
		})
	]
});
export default SvgBrushSmoothIcon;
